'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rcSelect = require('rc-select');

var _rcSelect2 = _interopRequireDefault(_rcSelect);

var _setImmediate = require('fbjs/lib/setImmediate');

var _setImmediate2 = _interopRequireDefault(_setImmediate);

var _utils = require('../utils');

var _rcEditorUtils = require('rc-editor-utils');

var _rcEditorUtils2 = _interopRequireDefault(_rcEditorUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getCurrentInlineStyle = _rcEditorUtils2["default"].getCurrentInlineStyle,
    getCurrentEntity = _rcEditorUtils2["default"].getCurrentEntity;

var Option = _rcSelect2["default"].Option;
var sizeArray = [];
for (var i = 12; i < 24; i += 2) {
    sizeArray.push(i);
}
var PREFIX = 'FONTSIZE_';
function customStyleFn(styleSet) {
    return styleSet.map(function (style) {
        if (style.indexOf(PREFIX) !== -1) {
            var fontSize = Number(style.substring(PREFIX.length));
            return {
                fontSize: fontSize
            };
        }
        return {};
    }).reduce(function (prev, curr) {
        return Object.assign(prev, curr);
    });
}
var FontSize = {
    constructor: function constructor(config) {
        var callbacks = {
            getEditorState: _utils.noop,
            setEditorState: _utils.noop,
            setInlineStyleOverride: _utils.noop
        };
        var toggleStyle = (0, _utils.getToggleFontStyleFunc)(PREFIX, callbacks);
        function changeSelect(_ref) {
            var key = _ref.key;

            var applyStyle = function applyStyle() {
                return toggleStyle('' + PREFIX + key);
            };
            if (callbacks.getEditorState().getSelection().isCollapsed()) {
                (0, _setImmediate2["default"])(applyStyle);
            } else {
                applyStyle();
            }
        }
        return {
            name: 'fontSize',
            callbacks: callbacks,
            customStyleFn: customStyleFn,
            component: function component(props) {
                var editorState = callbacks.getEditorState();
                var currentStyle = getCurrentInlineStyle(editorState);
                var currentFontSize = currentStyle && currentStyle.find(function (item) {
                    return item.indexOf('' + PREFIX) !== -1;
                });
                var fontSizeNumber = currentFontSize ? currentFontSize.substring(PREFIX.length) : 16;
                var options = sizeArray.map(function (item) {
                    return _react2["default"].createElement(
                        Option,
                        { key: item, value: item + '', style: { fontSize: item } },
                        item,
                        'px'
                    );
                });
                var value = {
                    key: fontSizeNumber + '',
                    label: fontSizeNumber + 'px'
                };
                return _react2["default"].createElement(
                    'span',
                    { onClick: function onClick(ev) {
                            ev.preventDefault();ev.stopPropagation();
                        } },
                    _react2["default"].createElement(
                        _rcSelect2["default"],
                        { labelInValue: true, prefixCls: config.prefixCls + '-select', onChange: changeSelect, style: { width: 80, marginRight: 6 }, value: value },
                        options
                    )
                );
            }
        };
    }
};
exports["default"] = FontSize;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-basic-style@0.3.6@rc-editor-plugin-basic-style/lib/FontSize/index.js
// module id = 125
// module chunks = 0 1 2